<template>  
    <div> 
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
		<div class="stepForm" v-if="success == '3'">
            <div class="mainTitle text-center mt-4 mb-3"> 
                <h3 class="mb-4">{{$t('acc_reqProcessing')}}</h3>
            </div> 
        </div>
        <div class="stepForm" v-if="success == true">
            <!-- <div class="mainTitle text-center mt-4 mb-3"> 
                <h3 class="mb-4">{{$t('reqVerify')}}</h3>
            </div>  -->
            <div class="CustomBlockWidth inMiddle-area whitebox p-4 middleBox">  
                <div class="congratulations">
                    <div class="logo_congrats">
                        <img src="../../../../static/fxView/images/congrats.png" alt="Icon">
                    </div>
                    <div class="subtitle">
                        <h3>{{$t('verf_dear')}} <span class="green">{{get_user.username}}</span></h3>
                        <p>Your {{type}} {{$t('acc_accountVerMsz1')}}</p>
                    </div>
                    <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
                        <router-link :to="'/account'" class="prism_btn btn_sm">{{$t('acc_backAccountList')}}</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="stepForm" v-if="success == false">
            <div class="mainTitle text-center mt-4 mb-3"> 
                <h3 class="mb-4">{{$t('acc_reqFailed')}}</h3>
            </div> 
            <div class="CustomBlockWidth inMiddle-area whitebox p-4 middleBox">  
                <div class="congratulations">
                    <div class="logo_congrats">
                        <img src="../../../../static/fxView/images/cross.svg" alt="Request Failed">
                    </div>
                    <div class="subtitle">
                        <h3>{{$t('verf_dear')}} <span class="green">{{get_user.username}}</span></h3>
                        <p>{{ res_msg }}</p> 
                    </div>
                    <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
                        <router-link :to="'/account'" class="prism_btn btn_sm">{{$t('acc_backAccountList')}}</router-link>
                    </div>
                </div>
            </div> 
        </div>
    </div> 
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'accounts',
        mixins: [fxViewMixins],
        data() {
            return {
               verify : '',
               type : '',
               success : '3',
               msg : '',
               pageLoader : false,
               response_msg : '',
               msg_type : '',
               res_msg: '',
            }
        },
        created(){
            //let query = Object.assign({}, this.$route.query);
            const _that = this
            setTimeout(function(){ 
                if(_that.$route.query.verify){
                    _that.verify = _that.$route.query.verify
                    _that.type = _that.$route.query.type
                    let input_json = {
                        'globalParams' : {
                            'verify' : _that.$route.query.verify.toString()
                        },
                        'localParams' : {'parameter' : _that , 'params' :'request-verify12'}
                    }
                    if(_that.$route.query.type == 'CHANGE LEVERAGE'){
                        _that._runAccountLeverageCheckOtp(input_json)
                    }else if(_that.$route.query.type == 'CHANGE PASSWORD'){
                        _that._runAccountPasswordCheckOtp(input_json)
                    }else if(_that.$route.query.type == 'INTERNAL TRANSFER'){
                        _that._runInternalTransferCheckOtp(input_json)
                    }
                }

            }, 3000);
            
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/manageAccounts/account-verify.vue